export const getDisplay = (block: boolean) => (block ? 'block' : 'inline-block');
